import RewardsStoreList from './RewardsStoreList';

export default RewardsStoreList;
